module.exports = __webpack_public_path__ + "img/icon-delete.8a1db8a7.svg";